import innerStyles from "./innerSelectForForm.module.css";
import { useEffect } from "react";

function SelectForForm({
  register,
  dataForm,
  inputProps,
  externalStyles,
  setValue,
  mode,
  errors = {},
  clearErrors,
}) {
  useEffect(() => {
    setValue(inputProps.key, dataForm?.[inputProps.key]);
    if (!!dataForm?.[inputProps.key] && clearErrors) {
      clearErrors(inputProps.key);
    }
  }, [dataForm]);
  return (
    <div>
      <label className={externalStyles?.label}>
        {inputProps.label}
        {inputProps.required && mode !== "view" && <span className={innerStyles["red-dot"]}>*</span>}
      </label>
      <select
        className={`${innerStyles["form-select"]} ${
          errors[inputProps.key] ? innerStyles["error-border"] : ""
        }`}
        style={externalStyles?.input}
        id={inputProps.key}
        disabled={inputProps.disabled || mode === "view"}
        {...register(inputProps.key, { required: inputProps.required })}>
        {inputProps.options.map((option) => {
          return <option value={option.id}>{option.value}</option>;
        })}
      </select>
    </div>
  );
}

export default SelectForForm;
